<div class="company-container">
  <div class="top-part">
    <div class="top-part-wrap">
      <div class="first-section d-flex align-items-center">
        <h5 class="mb-0 table-title">Move To Floor</h5>
        <div class="username-select">
          <select
            class="form-select"
            [(ngModel)]="user.userID"
            (change)="getInventory(user.userID)"
          >
            <option *ngFor="let user of users" [ngValue]="user.id">
              {{ user.fullName }}
            </option>
          </select>
        </div>
      </div>
      <div
        class="second-section d-flex align-items-center justify-content-end"
        id="customDrpdown"
      >
        <span matTooltip="Filter Data" matTooltipPosition="above">
          <button
            class="btn filter-btn ms-2"
            data-bs-target="#filterData"
            data-bs-toggle="modal"
          >
            <img
              style="width: 22px"
              src="../../../assets/Pricingscreen/filter.svg"
            />
          </button>
        </span>
        <div class="searchbar d-flex ms-2" style="width: 60%">
          <img class="search me-2" src="../../../assets/icons/searchbar.svg" />
          <input
            type="text"
            class="search-input"
            placeholder="Search"
            [(ngModel)]="searchQuery"
            (input)="onSearch()"
          />
        </div>
        <button
          class="create-btn disable-btn ms-2"
          data-bs-target="#addUserModalToggle"
          data-bs-toggle="modal"
          [hidden]="hidebtn"
        >
          Move To
        </button>
        <div
          class="create-btn add-btn ms-2"
          data-bs-target="#addUserModalToggle"
          data-bs-toggle="modal"
          [hidden]="!hidebtn"
          (click)="addJournal()"
        >
          Move To
        </div>
      </div>
    </div>
  </div>

  <section class="intro">
    <div class="table-container">
      <table class="table category-table table-condensed">
        <thead class="main-head sticky-top">
          <tr>
            <th scope="col" style="align-items: center" class="text-trasnform">
              <div class="form-check d-flex align-items-center">
                <input
                  style="height: 20px; width: 20px; margin-right: 10px"
                  class="form-check-input me-3"
                  id="flexCheckDefault1"
                  type="checkbox"
                  [checked]="headerCheckboxSelected"
                  (change)="toggleAllCheckboxes()"
                />
                <div *ngIf="showDept">
                  <label for="flexCheckDefault" class="ms-2">Department</label>
                  <i
                    class="fa-regular fa-circle-xmark text-danger ms-1"
                    (click)="clearFilter('Department')"
                    *ngIf="filterDepartmentIDs.length > 0"
                  ></i>
                </div>
              </div>
            </th>
            <th scope="col" [hidden]="showCtg" class="text-trasnform">
              Category
              <i
                class="fa-regular fa-circle-xmark text-danger"
                (click)="clearFilter('Category')"
                *ngIf="filterCategoriesIDs.length > 0"
              ></i>
            </th>
            <th scope="col" [hidden]="showColor" class="text-trasnform">
              Week Color
              <i
                class="fa-regular fa-circle-xmark text-danger"
                (click)="clearFilter('Color')"
                *ngIf="filterColorIDs.length > 0"
              ></i>
            </th>
            <th scope="col" [hidden]="showLocation" class="text-trasnform">
              Location
              <i
                class="fa-regular fa-circle-xmark text-danger"
                (click)="clearFilter('Location')"
                *ngIf="filterLocationIDs.length > 0"
              ></i>
            </th>
            <th scope="col" [hidden]="showTOLocation" class="text-trasnform">
              To Location
            </th>
            <!-- <th scope="col">Barcode </th> -->
            <th scope="col" [hidden]="showInventorya" class="text-trasnform">
              OnHand
            </th>
            <th scope="col" class="text-trasnform">Move Qty</th>
            <th scope="col" class="text-trasnform" style="text-align: center">
              Actions
            </th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let item of Deptpriceconfigarray; let i = index">
            <td class="d-flex g-2" style="align-items: center">
              <div class="form-check d-flex align-items-center">
                <input
                  style="height: 20px; width: 20px; margin-right: 10px"
                  class="form-check-input me-3"
                  type="checkbox"
                  id="flexCheckDefault1"
                  [checked]="headerCheckboxSelected || !item.checked"
                  (change)="handleCheckboxChange(i, item)"
                />
              </div>
              <div class="d-flex align-items-center" *ngIf="showDept">
                <i class="icon-cover me-2"><img [src]="item.dIcon" /></i>
                <span style="font-size: 14px; font-weight: 700">{{
                  item.departmentDescr
                }}</span>
              </div>
            </td>
            <td [hidden]="showCtg">
              <div class="d-flex align-items-center">
                <i class="icon-cover me-2"><img [src]="item.cIcon" /></i>
                <span>{{ item.categoryName }}</span>
              </div>
            </td>
            <td [hidden]="showColor">
              <div class="d-flex align-items-center">
                <span [style.backgroundColor]="item.color" class="bgColor">{{
                  item.displayName
                }}</span>
              </div>
            </td>
            <td [hidden]="showLocation">{{ item.locationTypeDesc }}</td>
            <td [hidden]="showTOLocation">
              <div>
                <select
                  class="custom-form-select form-select"
                  aria-label="Default select example"
                  [(ngModel)]="item.toLocationId"
                >
                  <option [ngValue]="0" disabled>Select Location</option>
                  <option
                    *ngFor="let loc of location; let i = index"
                    [ngValue]="loc.id"
                  >
                    {{ loc.name }}
                  </option>
                </select>
              </div>
            </td>
            <!-- <td [hidden]="showInventorya">{{item.barcode}}</td> -->
            <td [hidden]="showInventorya" class="text-center pe-3">
              {{ item.qty }}
            </td>
            <td>
              <div class="counted-val">
                <input
                  type="text"
                  class="form-control"
                  id="countedVal"
                  placeholder="Value"
                  (keydown)="showCountBtn($event, i, item)"
                  [(ngModel)]="item.adjQty"
                />
              </div>
            </td>
            <td style="text-align: center">
              <div class="btn-group dropleft" style="gap: 10px">
                <span matTooltip="Move To Floor" matTooltipPosition="above">
                  <button
                    type="button"
                    class="action-drop me-2"
                    [hidden]="!item.checked && item.toLocationId > 0"
                  >
                    <i
                      ><img
                        width="25"
                        src="../../../assets/Pricingscreen/ic_product.svg"
                    /></i>
                  </button>
                </span>
                <button
                  type="button"
                  class="action-drop me-2"
                  [hidden]="item.checked || !(item.toLocationId > 0)"
                  (click)="checkIndex(item)"
                >
                  <i
                    ><img
                      width="25"
                      src="../../../assets/Pricingscreen/movebtn.svg"
                      class="svg-icon"
                  /></i>
                </button>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </section>
</div>

<!--Boostrap modal for filter data-->
<div
  class="modal fade"
  id="filterData"
  aria-hidden="true"
  aria-labelledby="exampleModalToggleLabel"
  tabindex="-1"
>
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="mb-0">Filters</h5>
      </div>
      <div class="modal-body p-0">
        <div class="filter d-flex">
          <div class="filter-labels">
            <h6 class="ps-4">Lists</h6>
            <div class="filter-labels-wrapper">
              <ul class="list-unstyled">
                <li (click)="selectedFilterCategory('Department')">
                  Department
                  <br />
                  <p *ngIf="filterDepartmentIDs.length > 0">
                    {{ filterDepartmentIDs.length }} selected
                  </p>
                </li>

                <li (click)="selectedFilterCategory('Category')">
                  Category
                  <br />
                  <p *ngIf="filterCategoriesIDs.length > 0">
                    {{ filterCategoriesIDs.length }} selected
                  </p>
                </li>

                <li (click)="selectedFilterCategory('Color')">
                  Color
                  <br />
                  <p *ngIf="filterColorIDs.length > 0">
                    {{ filterColorIDs.length }} selected
                  </p>
                </li>
                <li (click)="selectedFilterCategory('Location')">
                  Location
                  <br />
                  <p *ngIf="filterLocationIDs.length > 0">
                    {{ filterLocationIDs.length }} selected
                  </p>
                </li>
              </ul>
            </div>
          </div>
          <div class="filter-data">
            <h6 class="ps-2">Selected by: {{ filterName }}</h6>
            <div class="filter-data-wrapper">
              <div class="row" *ngIf="filterName == 'Department'">
                <div
                  class="col-lg-4 col-sm-6"
                  *ngFor="
                    let data of DeptpriceconfigarrayforFilters;
                    let idx = index
                  "
                >
                  <div
                    class="conntent-box"
                    [ngClass]="{ active: data.isSelected == true }"
                    (click)="collectFilterParameters(data.departmentId)"
                  >
                    <i><img class="filtericon" [src]="data.dIcon" /></i>
                    <span
                      class="mt-2"
                      style="font-size: 13px; color: black; text-wrap: nowrap"
                      >{{ data.departmentDescr }}
                    </span>
                  </div>
                </div>
              </div>

              <div class="row" *ngIf="filterName == 'Category'">
                <div
                  class="col-lg-3 col-sm-6"
                  *ngFor="
                    let data of DeptpriceconfigarrayforFilters;
                    let idx = index
                  "
                  (click)="collectFilterParameters(data.categoryId)"
                >
                  <div
                    class="conntent-box"
                    [ngClass]="{ active: data.cIsSelected == true }"
                  >
                    <i><img class="filtericon" [src]="data.cIcon" /></i>
                    <span
                      class="mt-2"
                      style="font-size: 13px; color: black; text-wrap: nowrap"
                    >
                      {{ data.categoryName }}
                    </span>
                  </div>
                </div>
              </div>

              <div class="row" *ngIf="filterName == 'Color'">
                <div
                  class="col-lg-3 col-sm-6"
                  *ngFor="
                    let data of DeptpriceconfigarrayforFilters;
                    let idx = index
                  "
                  (click)="collectFilterParameters(data.productionCycleId)"
                >
                  <div
                    class="conntent-box"
                    [ngClass]="{ active: data.pIsSelected == true }"
                    [style.BackgroundColor]="data.color"
                  >
                    <span class="mt-2" style="font-size: 13px; color: black">
                      {{ data.displayName }}
                    </span>
                  </div>
                </div>
              </div>
              <div class="row" *ngIf="filterName == 'Location'">
                <div
                  class="col-lg-3 col-sm-6"
                  *ngFor="
                    let data of DeptpriceconfigarrayforFilters;
                    let idx = index
                  "
                  (click)="collectFilterParameters(data.locationId)"
                >
                  <div
                    class="conntent-box"
                    [ngClass]="{ active: data.lIsSelected == true }"
                    *ngIf="data.locationTypeDesc"
                  >
                    <span class="mt-2" style="font-size: 13px; color: black">
                      {{ data.locationTypeDesc }}
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="modal-footer d-flex justify-content-end">
        <div class="footer-wrapper">
          <button
            class="btn modal-btn me-2"
            data-bs-dismiss="modal"
            aria-label="Close"
            style="background-color: #ffffff; color: #175f91"
          >
            Cancel
          </button>
          <button
            class="btn modal-btn me-2"
            data-bs-dismiss="modal"
            aria-label="Close"
            style="background-color: #175f91; color: white"
            (click)="getFilterData()"
          >
            Apply
          </button>
        </div>
      </div>
    </div>
  </div>
</div>

<button
  style="display: none"
  #tagButton
  data-bs-toggle="modal"
  href="#setLocation"
>
  btn
</button>
<div
  class="modal fade"
  id="setLocation"
  tabindex="-1"
  role="dialog"
  aria-labelledby="exampleModalCenterTitle"
  aria-hidden="true"
>
  <div class="custom-modal-dialog modal-dialog modal-dialog-centered">
    <div class="modal-content">
      <div class="custom-modal-body modal-body">
        <div class="modal-body-wraapper mt-3" style="padding-inline: 0.8rem">
          <div class="mb-4">
            <p>Please designate a location for the records.</p>
            <p class="mt-2" style="font-weight: 500">
              Should you wish to specify your own location, you may skip this
              section.
            </p>
          </div>
          <div class="selector">
            <div class="custom-label">
              <label class="ms-0">Choose Location</label>
              <p>:</p>
            </div>
            <select
              class="custom-form-select form-select"
              aria-label="Default select example"
              [(ngModel)]="locationID"
            >
              <option *ngFor="let loc of location" [ngValue]="loc.id">
                {{ loc.name }}
              </option>
            </select>
          </div>
        </div>
      </div>
      <div
        class="custom-modal-footer modal-footer mt-0 mb-2 border-0 justify-content-end"
        style="padding-right: 2.2rem"
      >
        <button
          class="modal-btn me-2"
          data-bs-target="#exampleModalToggle2"
          data-bs-toggle="modal"
          (click)="toggleAllCheckboxes()"
        >
          Skip
        </button>
        <button
          class="modal-btn"
          data-bs-target="#exampleModalToggle2"
          data-bs-toggle="modal"
          style="
            background-color: rgb(23, 95, 145);
            color: white;
            white-space: nowrap;
          "
          (click)="changeLoc(locationID)"
        >
          Select
        </button>
      </div>
    </div>
  </div>
</div>